import React from 'react'
import PropTypes from 'prop-types'
import { FormProvider, useForm } from 'react-hook-form'
import { Form as AntdForm } from 'antd'
import { yupResolver } from '@hookform/resolvers'
import * as yup from 'yup'
import { useDeepCompareEffect } from 'react-use'
import Modal from '@components/Modal'

const ModalForm = ({
  children,
  onSubmit,
  defaultValues = {},
  validationSchema = yup.object({}),
  formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
  },
  visible = false,
  okText = 'Ok',
  title = 'Form',
  onCancel = () => {},
}) => {
  useDeepCompareEffect(() => {
    console.log('default value change')
    const formValue = methods.getValues()
    Object.keys(formValue).forEach((key) => {
      try {
        methods.setValue(key, defaultValues[key])
      } catch (e) {
        console.log(e)
        throw e
      }
    })
    return () => {}
  }, [defaultValues])
  const methods = useForm({
    defaultValues,
    resolver: yupResolver(validationSchema),
  })
  const handleSubmit = (data) => {
    // console.log({ data, e })
    onSubmit(data)
  }

  return (
    <FormProvider {...methods}>
      <Modal
        visible={visible}
        title={title}
        okText={okText}
        cancelText="Cancel"
        onOk={methods.handleSubmit(handleSubmit)}
        onCancel={onCancel}
      >
        <AntdForm {...formItemLayout} initialValues={defaultValues}>
          {children}
        </AntdForm>
      </Modal>
    </FormProvider>
  )
}

ModalForm.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  onSubmit: PropTypes.func,
  defaultValues: PropTypes.object,
  validationSchema: PropTypes.object,
  formItemLayout: PropTypes.object,
  visible: PropTypes.bool,
  okText: PropTypes.string,
  title: PropTypes.string,
  onCancel: PropTypes.func,
}

export default ModalForm
